module.exports = __webpack_public_path__ + "static/media/me.214b3f9d.jpg";